import styled from 'styled-components';
import { Tree } from 'antd';

export const CustomParagraph = styled.p`
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
	letter-spacing: -0.5%;
`;

export const CustomTree = styled(Tree)`
	.ant-tree-treenode {
		margin-bottom: 16px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.ant-tree-child-tree .ant-tree-treenode {
		margin-bottom: 16px;

		&:last-child {
			margin-bottom: 0;
		}
	}
`;
